import { Navigate } from "react-router-dom";

export default function RedirectNotificationTalk({ path }: { path: string }) {
    if (path === "customer") return <Navigate to="/customer/tracking" replace />;
    if (path === "center") return <Navigate to="/support/courier-inquiry" replace />;
    if (path === "member") return <Navigate to="/login" replace />;

    return null;
}
